import { useRoutes } from "react-router-dom";
import { ProfileRoutes } from "./routes/profile.routes";
import { useAppLayout } from "@dataone/lib";
import { useEffect } from "react";
import styled from "styled-components";
import ProfilePage from "./pages/ProfilePage";

const ProfileApp = () => {
  // const element = useRoutes(ProfileRoutes);

  useEffect(() => {
    useAppLayout.setState({ isSmartSearchVisible: false });
    useAppLayout.setState({ isResponseVisible: false });
  }, []);

  return (
    <StyledProfileApp id="profile-modal">
      {/* {element} */}
      <ProfilePage />
    </StyledProfileApp>
  );
};

export default ProfileApp;

const StyledProfileApp = styled.div`
  height: calc(100vh - 80px);
`;
